import { render, staticRenderFns } from "./WikiAudit.vue?vue&type=template&id=04507adf&scoped=true&"
import script from "./WikiAudit.vue?vue&type=script&lang=js&"
export * from "./WikiAudit.vue?vue&type=script&lang=js&"
import style0 from "./WikiAudit.vue?vue&type=style&index=0&id=04507adf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04507adf",
  null
  
)

export default component.exports